import script from "./AdminFeatureRequestFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFeatureRequestFormView.vue?vue&type=script&setup=true&lang=js"

import "./AdminFeatureRequestFormView.vue?vue&type=style&index=0&id=c8a7fd26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a7fd26"]])

export default __exports__